/**
 * Centralized Product Branding & System Identity Configuration
 * Single authoritative source of product names, versions, links, and white-label settings.
 */

export interface ProductBranding {
  productName: string;
  providerConsoleTitle: string;
  customerPanelTitle: string;
  tagline: string;
  companyName: string;
  companyWebsite: string;
  supportUrl: string;
  docsUrl: string;
  version: string;
  releaseName: string;
  copyright: string;
  defaultLanguage: "en" | "ro";
  supportedLanguages: Array<{ code: string; name: string; nativeName: string; flag: string }>;
  features: {
    whiteLabeling: boolean;
    passkeys: boolean;
    totp2FA: boolean;
    wordpressManager: boolean;
    cpanelMigration: boolean;
    cloudflareEdge: boolean;
    stalwartMail: boolean;
    powerDns: boolean;
  };
}

export const BRANDING: ProductBranding = {
  productName: "KubeHost",
  providerConsoleTitle: "KubeHost Provider Console",
  customerPanelTitle: "KubeHost Hosting Portal",
  tagline: "Commercial Kubernetes Hosting Platform",
  companyName: "KubeHost Hosting Technologies",
  companyWebsite: "https://github.com/edward1987/k8s-websites-manager",
  supportUrl: "https://github.com/edward1987/k8s-websites-manager/issues",
  docsUrl: "https://github.com/edward1987/k8s-websites-manager/tree/master/docs",
  version: process.env.NEXT_PUBLIC_APP_VERSION || "1.0.0",
  releaseName: "Titan",
  copyright: `© ${new Date().getFullYear()} KubeHost. All rights reserved.`,
  defaultLanguage: "en",
  supportedLanguages: [
    { code: "en", name: "English", nativeName: "English (US)", flag: "🇺🇸" },
    { code: "ro", name: "Romanian", nativeName: "Română", flag: "🇷🇴" },
  ],
  features: {
    whiteLabeling: true,
    passkeys: true,
    totp2FA: true,
    wordpressManager: true,
    cpanelMigration: true,
    cloudflareEdge: true,
    stalwartMail: true,
    powerDns: true,
  },
};

export default BRANDING;
